import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {PaisesModel} from "./paises.model";
import {PaisesService} from './paises.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";


@Component({
  selector: 'app-paises-form',
  templateUrl: './paises-form.component.html'
})
export class PaisesFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  pais: PaisesModel = new PaisesModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private paisesService: PaisesService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_pais'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarPais');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarPais') : this.func.traduzir('front.cadastrarNovoPais');
      }

      if (!id) {
        return;
      }

      this.paisesService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.title = this.func.traduzir('front.editarPais')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarPais') + ': ' + json.Payload[0].nome;
            }
            this.pais = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.paisesService.editar(values, values.id);
    } else {
      result = this.paisesService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'paises']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/paises/paises-form.component.ts